<template>
  <credit-widget
    class="cashflow-insights"
    data-testid="cashflow-insights-widget"
  >
    <template slot="widget-header">
      <i-icon
        class="icon i-text-neutral-110"
        symbol="small-money-cash-bag-dollar"
        :size="16"
      ></i-icon>
      <span>Cashflow Insights</span>
    </template>
    <template slot="widget-content">
      <div class="line large">
        <span>Total Net</span>
        <credit-widget-value
          :value="totalNet"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Total Credits</span>
        <credit-widget-value
          :value="totalCredits"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Total Debits</span>
        <credit-widget-value
          :value="totalDebits"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Average Credit Amount</span>
        <credit-widget-value
          :value="averageCreditAmount"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Average Debit Amount </span>
        <credit-widget-value
          :value="averageDebitAmount"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Average Daily Balance</span>
        <credit-widget-value
          :value="averageDailyBalance"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Count of Self Transfers</span>
        <credit-widget-value :value="selfTransfers"></credit-widget-value>
      </div>
    </template>
  </credit-widget>
</template>

<script>
import { mapState } from 'vuex';
import CreditWidget from '@/V2/credit/widgets/CreditWidget';
import CreditWidgetValue from '@/V2/credit/widgets/CreditWidgetValue';
import { iIcon } from '@inscribe/signal';

export default {
  name: 'CashflowInsights',
  components: { CreditWidget, CreditWidgetValue, iIcon },
  computed: {
    ...mapState({
      credit: 'credit',
    }),
    averageDebitAmount() {
      return this.credit?.customerCashflow?.average_debit_amount;
    },
    averageCreditAmount() {
      return this.credit?.customerCashflow?.average_credit_amount;
    },
    averageDailyBalance() {
      return this.credit?.customerCashflow?.average_daily_balance;
    },
    totalCredits() {
      return this.credit?.customerCashflow?.total_credits;
    },
    totalDebits() {
      return this.credit?.customerCashflow?.total_debits;
    },
    totalNet() {
      return this.credit?.customerCashflow?.total_net;
    },
    selfTransfers() {
      return this.credit?.customerCashflow?.count_self_transfers;
    },
  },
};
</script>
